module.exports = __webpack_public_path__ + "school/img/head.6c5be9b0.png";